function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  viewBox: "0 0 100 100",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M57.399 53.36 36.286 32.248a1 1 0 0 0-1.707.707v46.427H24V31.556c0-6.075 4.925-11 11-11a11 11 0 0 1 7.778 3.222l22.026 22.026 3.53-5.105a2 2 0 0 1 3.612.777l4.116 22.416a1 1 0 0 1-1.164 1.164l-22.43-4.119a2 2 0 0 1-.78-3.61z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/directions/ic-turn-sharply-right.svg";
export { SvgComponent as ReactComponent };